// src/components/navbar/Navbar.js
import React, { useState } from 'react';
import { navlinksdata } from '../../constants';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className='bg-black w-full h-24 sticky top-0 z-50  
    flex justify-between items-center font-titleFont text-white border-b-[1px] border-b-gray-600 px-4 md:px-20'>
      {/* Logo or Branding */}
      <div className="text-white text-2xl font-bold">RayLab</div>

      {/* Navbar Links */}
      <nav className="hidden md:flex items-center gap-4">
        <ul className="flex items-center gap-4">
          {navlinksdata.map(({ _id, title, link, isRoute, routePath }) => (
            <li
              className="text-base font-normal text-white tracking-wide cursor-pointer hover:text-designColor duration-300"
              key={_id}
            >
              {isRoute ? (
                <RouterLink
                  to={routePath}
                  className="cursor-pointer"
                  activeClassName="active"
                >
                  {title}
                </RouterLink>
              ) : (
                <Link
                  to={link}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="cursor-pointer"
                >
                  {title}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden text-white focus:outline-none"
        onClick={toggleMenu}
      >
        {isOpen ? (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        )}
      </button>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-40 flex">
          <div className="w-64 bg-black border-r border-gray-600 p-4">
            <button
              className="text-white focus:outline-none"
              onClick={toggleMenu}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <ul className="flex flex-col gap-4 mt-4">
              {navlinksdata.map(({ _id, title, link, isRoute, routePath }) => (
                <li
                  key={_id}
                  className="text-base font-normal tracking-wide cursor-pointer hover:text-designColor duration-300"
                  onClick={() => setIsOpen(false)}
                >
                  {isRoute ? (
                    <RouterLink
                      to={routePath}
                      className="block py-2 px-4 hover:bg-gray-800 rounded"
                      activeClassName="active"
                    >
                      {title}
                    </RouterLink>
                  ) : (
                    <Link
                      to={link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      className="block py-2 px-4 hover:bg-gray-800 rounded"
                    >
                      {title}
                    </Link>
                  )}
                </li>
              ))}
              <li
                className="text-base font-normal tracking-wide cursor-pointer hover:text-designColor duration-300"
                onClick={() => setIsOpen(false)}
              >
                <RouterLink
                  to="/ongoing-projects"
                  className="block py-2 px-4 hover:bg-gray-800 rounded"
                >
                  Ongoing Projects
                </RouterLink>
              </li>
            </ul>
          </div>
          <div
            className="flex-grow"
            onClick={() => setIsOpen(false)}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Navbar;

